const o = new Map(Object.entries({
  Æ: "Ae",
  Ð: "D",
  Ø: "O",
  Þ: "Th",
  ß: "ss",
  æ: "ae",
  ð: "d",
  ø: "o",
  þ: "th",
  Đ: "D",
  đ: "d",
  Ħ: "H",
  ħ: "h",
  ı: "i",
  Ĳ: "IJ",
  ĳ: "ij",
  ĸ: "k",
  Ŀ: "L",
  ŀ: "l",
  Ł: "L",
  ł: "l",
  ŉ: "'n",
  Ŋ: "N",
  ŋ: "n",
  Œ: "Oe",
  œ: "oe",
  Ŧ: "T",
  ŧ: "t",
  ſ: "s"
}));
function r(n) {
  n = n.normalize("NFD");
  let u = "";
  for (let t = 0; t < n.length; t++) {
    const e = n[t];
    e >= "̀" && e <= "ͯ" || e >= "︠" && e <= "︣" || (u += o.get(e) ?? e);
  }
  return u;
}
export {
  r as d
};
